import axios from 'axios';

import cfac22 from '../cfac22';

export default function establishmentRatings(uId, establishmentId, rating, userComment, aliasName) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        `${cfac22('API_HOST_V2')}/establishments/ratings`,
        {
          payload: {
            aliasName,
            rating,
            establishmentId,
            userComment
          }
        },
        { headers: { 'Full-Url': window.location.href }, withCredentials: true }
      ).
      then((result) => {
        // console.log("RESULT_RATINGS: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_RATINGS: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKE:", error);
      reject(error);
    });
  });
}
